// @ts-nocheck
// TODO: tighten types after migration
import { ApolloClient, InMemoryCache } from "@apollo/client";

const storeClient = new ApolloClient({
    uri: 'https://api-ap-south-1.hygraph.com/v2/clob4hukwihfn01t5e6ja5s9b/master',
    cache: new InMemoryCache()
});

export default storeClient;


